import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dropdown-content" }

import { ref, nextTick } from 'vue';
import { dropDownHelper } from './dropDownHelper';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import CodeIcon from 'vue-material-design-icons/CodeBrackets.vue';
import Dots from 'vue-material-design-icons/DotsVertical.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownMenu',
  props: {
  goLeft: {
    type: Boolean,
    default: false,
  },
  dropDownIcon: {
    type: String,
    default: 'dots',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  useColourOnActive: {
    type: Boolean,
    default: false,
  },
},
  emits: ["isUp", "open"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const isUp = ref(false);

function toggleOpen() {
  if (props.disabled) {
    return;
  }

  isOpen.value = !isOpen.value;
  refresh();
}

function close() {
  isOpen.value = false;
  refresh();
}

function refresh() {
  nextTick(() => {
    isUp.value = dropDownHelper.isDropDownUp();
    emit('isUp', isUp.value);
    emit('open', isOpen.value);
  });
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown", { 'is-active': isOpen.value, 'is-disabled': __props.disabled }])
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "dropdown-trigger",
      onClick: toggleOpen
    }, [
      (__props.dropDownIcon === 'none')
        ? _renderSlot(_ctx.$slots, "trigger", { key: 0 })
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: _normalizeClass(["dropdown-colours", { active: isOpen.value, 'use-colour': __props.useColourOnActive }])
          }, [
            (__props.dropDownIcon === 'big-add-circle')
              ? (_openBlock(), _createBlock(AddIcon, {
                  key: 0,
                  title: "",
                  class: "big-add-circle icon-3x"
                }))
              : _createCommentVNode("", true),
            (__props.dropDownIcon === 'dots')
              ? (_openBlock(), _createBlock(Dots, {
                  key: 1,
                  class: "dots icon-1-5x"
                }))
              : _createCommentVNode("", true),
            (__props.dropDownIcon === 'variable')
              ? (_openBlock(), _createBlock(CodeIcon, {
                  key: 2,
                  class: _normalizeClass(["icon-1-2x", { clicked: isOpen.value }])
                }, null, 8, ["class"]))
              : _createCommentVNode("", true)
          ], 2))
    ])), [
      [_directive_click_away, close]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-menu", { 'go-left': __props.goLeft }]),
      id: "dropdown-menu",
      role: "menu"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2)
  ], 2))
}
}

})